export default {
  // baseURL: 'http://dicore.uz:5001/api/v1', // Dicore
  // baseURL: 'http://zk.uz:8084/api/v1', // ZK
  baseURL: 'https://api.yangimahalla.uz/api/v1', // Production/
  // baseURL: 'http://192.168.31.12:8004/api/v1', // Muhammadamin
  // baseURL: 'http://192.168.1.132:8091/api/v1', // Xamza/
  // baseURL: 'http://192.168.31.26:8005/api/v1', // Abubakir
  // baseURL: 'http://192.168.31.70:8005/api/v1', // Xasan aka
  // baseURL: 'https://3c14-213-230-87-91.eu.ngrok.io/api/v1', // Ngrok
  // baseURL: 'http://src.zk.uz:6006/api/v1'
}

// password: GC1q2w3e4r5t!